var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import ClockRewindSvg from './clock-rewind.icon.svg';
export const ClockRewindIcon = (iconInstanceProps) => (_jsx(Icon, { ...iconInstanceProps, SvgComponent: ClockRewindSvg }));
_react_refresh_temp_1 = ClockRewindIcon;
$RefreshReg$(_react_refresh_temp_1, "ClockRewindIcon");
